import { render, staticRenderFns } from "./placard_apply_for_invoice_list.vue?vue&type=template&id=2d81af41&scoped=true"
import script from "./placard_apply_for_invoice_list.vue?vue&type=script&lang=js"
export * from "./placard_apply_for_invoice_list.vue?vue&type=script&lang=js"
import style0 from "./placard_apply_for_invoice_list.vue?vue&type=style&index=0&id=2d81af41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81af41",
  null
  
)

export default component.exports